import useViewModel from "./viewModel";
import View from "./view";

const PurchaseSubscription = () => {
  const viewModel = useViewModel();

  return <View {...viewModel} />;
};

export default PurchaseSubscription;
